import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=2a45ea48"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports